module.exports = __webpack_public_path__ + "img/latitude.5bc1a60a.svg";